import React from 'react';
import './MessageBox.scss';
import * as PropTypes from 'prop-types';

const MessageBox = ({children, className = '', ...props}) => (
  <div className={`message-box ${className}`} {...props}>
    {children}
  </div>
);

MessageBox.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default MessageBox;
